import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const boProductApi = {

    //刪除訂單
    "queryMonthBill": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}boproduct/getMonthBillForAgent`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                descriptionc4: null,
                lastmodifieddate: "",
                verify: -1,
            }
        }
    },

}

export default boProductApi